<template>
    <div class="feedback-step question--multi-choice">
        <div class="heading-third--grey ">{{ feedbackData.text }}</div>
        <div class="multi-choice-tags">
            <div v-for="(tag, index) in feedbackData.options['tags']"
                :key="index"
                class="button-ths button-ths--link-pink"
                :class="[{'selected': selectedTag === tag}]"
                @click="selectTag(tag)">
                <span>{{ tag }}</span>
            </div>
        </div>
        <QuestionError :showEmptyError="showEmptyError" />
    </div>
</template>

<script>
    import QuestionError from '@/components/QuestionError.vue'

    export default {
        name: "StepMultiChoice",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {},
            showEmptyError: {
                type: Boolean,
                default: false
            }
        },
        components: {QuestionError},
        data() {
            return {
                selectedTags: [],
                selectedTag: '',
            }
        },
        methods: {
            selectTag(tag) {
                /* if (!this.selectedTags.includes(tag)) {
                    this.selectedTags.push(tag);
                } else {
                    let index = this.selectedTags.indexOf(tag);
                    if (index > -1) {
                        this.selectedTags.splice(index, 1);
                    }
                } */
                if (this.selectedTag === tag) {
                    this.selectedTag = '';
                    this.$emit('updateProgress', false);
                } else {
                    this.selectedTag = tag;
                    this.$emit('updateProgress', true);
                }
                this.$emit('hideError')
            }
        },
        mounted() {
            if (this.savedAnswer) {
                this.selectedTag = this.savedAnswer.tags;
            }
        },
        computed: {
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({
                        tags: this.selectedTag,
                    }),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.selectedTag == '') ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.selectedTag = this.savedAnswer.tags;
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    //this.yesNo = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
